import React, { Component, PropTypes } from 'react';

class Confirm extends Component {
  render() {
    return (
      <main className="app-body">
        <div className="message-box">
          <p>Vuoi confermare l’operazione di trasferimento con il Tinabalike?</p>
        </div>
        <div className="clearfix">
          <button className="light" onClick={(e) => { e.preventDefault(); this.props.resign(); }}> Annulla</button>
          <button onClick={(e) => { e.preventDefault(); this.props.onConfirm(); }}> Prosegui</button>
        </div>
      </main>
    );
  }
}

Confirm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  resign: PropTypes.func.isRequired
};

export default Confirm;



/** WEBPACK FOOTER **
 ** ./src/components/Confirm.jsx
 **/